<p-card styleClass="flex w-full h-full p-4">
    <ng-template pTemplate="header">
        <div class="flex justify-between items-center">
            <h2>Location Recruiting Progress</h2>
        </div>
    </ng-template>

    <div *ngIf="loading" class="text-center m-t">
        <p>Loading location data...</p>
    </div>

    <div *ngIf="error" class="text-center m-t text-danger">
        <p>{{ error }}</p>
    </div>

    <div *ngIf="!loading && !error" class="flex flex-wrap gap-3 space-y-6 max-h-[340px] overflow-y-auto pr-4">
        <div *ngFor="let item of locationData" class="location-item bg-white dark:bg-surface-900 shadow-sm hover:shadow-md dark:shadow-surface-50 w-49/100">
            <div class="flex justify-between items-center mb-2">
                <h5 class="text-lg font-semibold">{{ item.data.name }}</h5>
            </div>

            <div class="grid grid-cols-2 gap-4">
                <!-- Original Goal Knob -->
                <div class="flex flex-col items-center">
                    <p-knob 
                        [(ngModel)]="item.originalDisplayPercentage" 
                        [readonly]="true"
                        [size]="120"
                        [strokeWidth]="10"
                        [textColor]="getKnobColor(item.originalPercentage)"
                        [valueColor]="getKnobColor(item.originalPercentage)"
                        [max]="100"
                        [valueTemplate]="item.originalPercentage.toString() + '%'">
                    </p-knob>
                    <div class="text-center mt-2">
                        <div class="font-semibold">Original / Goal</div>
                        <div>{{ item.data.currentOriginal }} / {{ item.data.original }}</div>
                    </div>
                </div>

                <!-- Actual Goal Knob -->
                <div class="flex flex-col items-center">
                    <p-knob 
                        [(ngModel)]="item.actualDisplayPercentage" 
                        [readonly]="true"
                        [size]="120"
                        [strokeWidth]="10"
                        [textColor]="getKnobColor(item.actualPercentage)"
                        [valueColor]="getKnobColor(item.actualPercentage)"
                        [max]="100"
                        [valueTemplate]="item.actualPercentage.toString() + '%'">
                    </p-knob>
                    <div class="text-center mt-2">
                        <div class="font-semibold">Actual / Goal</div>
                        <div>{{ item.data.currentActual }} / {{ item.data.actual }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-card> 